const e=e=>"wallet"===e.type&&"privy"===e.wallet_client_type&&"embedded"===e.connector_type;export{e as isEmbeddedWalletAccount};
